/**
 * Parse a user-entered currency amount into integer cents (2dp).
 * Accepts strings like "5,781.26". Empty/null/invalid → 0.
 */
export function toCents(value) {
	if (value === null || value === undefined) return 0;
	if (typeof value === "number") {
		if (!Number.isFinite(value)) return 0;
		return Math.round(value * 100);
	}
	const s = String(value).trim();
	if (s === "") return 0;
	const normalized = s.replace(/,/g, "");
	const n = parseFloat(normalized);
	if (!Number.isFinite(n)) return 0;
	return Math.round(n * 100);
}

/** Integer cents → "0.00" string. */
export function fromCents(cents) {
	const n = Number(cents);
	if (!Number.isFinite(n)) return "0.00";
	return (n / 100).toFixed(2);
}

